import React, { useState, useRef, useEffect } from 'react'

import { useTheme } from '@mui/material/styles'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import ReactStars from 'react-rating-stars-component'
import GeneratedAvatar from 'components/Common/GeneratedAvatar'
import moment from 'moment'

const ReviewCard = props => {
  const [overflowActive, setOverflowActive] = useState(false)
  const [showMore, setShowMore] = useState(false)
  const overflowingText = useRef(null)

  const theme = useTheme()
  const checkOverflow = textContainer => {
    if (textContainer)
      return (
        textContainer.offsetHeight < textContainer.scrollHeight || textContainer.offsetWidth < textContainer.scrollWidth
      )
    return false
  }

  const formatTime = () => {
    if (props.isUnixTimeStamp) {
      return moment.unix(props.time).fromNow()
    } else {
      return moment(props.time).fromNow()
    }
  }

  useEffect(() => {
    if (checkOverflow(overflowingText.current)) {
      setOverflowActive(true)
      return
    }

    setOverflowActive(false)
  }, [overflowActive])

  const onShowMore = event => {
    setShowMore(!showMore)
  }

  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        border: `1px solid ${theme.palette.color.darkBlue10}`,
        padding: '5px',
        borderRadius: '10px',
      }}
    >
      <Box
        sx={{
          padding: '1rem 1rem 0 1rem',
        }}
      >
        {props.authorImageUrl ? (
          <GeneratedAvatar width={40} height={40} src={props.authorImageUrl} alt={props.authorName} />
        ) : (
          <GeneratedAvatar width={40} height={40} text={props.authorName} />
        )}
      </Box>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <Typography variant="overline1" color="primary">
          {props.authorName}
        </Typography>

        <Typography
          variant="caption"
          component="span"
          color="primary"
          sx={
            !showMore
              ? {
                  width: '100%',
                  textAlign: 'left',
                  fontStyle: 'italic',
                  overflow: 'hidden',
                  overflowWrap: 'break-word',
                  display: '-webkit-box',
                  '-webkit-line-clamp': '2',
                  '-webkit-box-orient': 'vertical',
                }
              : {
                  textAlign: 'left',
                  fontStyle: 'italic',
                }
          }
        >
          {props.text}
        </Typography>

        {!showMore && (
          <Typography
            component="span"
            variant="caption"
            onClick={onShowMore}
            color="primary"
            sx={{
              fontWeight: 'bold',
              display: 'inline-block',
              alignSelf: 'flex-end',
              cursor: 'pointer',
            }}
          >
            More
          </Typography>
        )}
        {!!showMore && (
          <Typography
            component="span"
            variant="caption"
            onClick={onShowMore}
            color="primary"
            sx={{
              fontWeight: 'bold',
              display: 'inline-block',
              alignSelf: 'flex-end',
              cursor: 'pointer',
            }}
          >
            Less
          </Typography>
        )}

        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end',
            flexWrap: 'wrap',
          }}
        >
          <Typography variant="overline2" color="primary">
            {formatTime()}
          </Typography>
          <Box sx={{ display: 'inline-flex', alignItems: 'center' }}>
            <ReactStars edit={false} isHalf={true} value={props.rating} />
            <Typography variant="overline2" color="primary" sx={{ fontSize: '10px', fontWeight: 'bold' }}>
              {props.rating}/5
            </Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

export default ReviewCard
